import _ from 'lodash';
import { useMsal, } from '@azure/msal-react';
import { useEffect, useContext, useState } from 'react';
import { AppSettings } from '../../config/app-settings.js';
import { FileApi } from "../../api/file/file-api";
import DocsAPI from "../../api/docs/docs-api-factory.js";
import { FileManagerSecondToolbar } from '../../components/files/file-manager-toolbar.jsx';
import { FileManagerFooter } from '../../components/files/file-manager-footer.jsx';
import { FileManagerPageHeader } from '../../components/files/file-manager-page-header.jsx';
import { FileManagerMainWindow } from '../../components/files/file-manager-main-window.jsx';
import { FileManagerTreeWindow } from '../../components/files/file-manager-tree-window.jsx';
import { PreviousVersionModal } from '../../components/files/previous-versions-modal.jsx';
import { FileFunctions } from '../../api/file/file-functions.js';
import { getFileFormat } from '../../api/docs/doc-functions.js';

export const ExtraFileManager = () => {
	const context = useContext(AppSettings);
	const { instance, inProgress, accounts } = useMsal();

	const [dataSideTree, setDataSideTree] = useState(null);
	const [consumption, setConsumption] = useState(null);
	const [rootFolderName, setRootFolderName] = useState("");
	const [fetchComplete, setFetchComplete] = useState(false);
	const [fetchInProgress, setFetchInProgress] = useState(false);
	const [selectedPath, setSelectedPath] = useState(null);
	const [pathHistory, setPathHistory] = useState([]);
	const [showVersionModal, setShowVersionModal] = useState(false);
	const [previousVersionsFile, setPreviousVersionsFile] = useState(null);
	const [showDeleted, setShowDeleted] = useState(false);
	const [multiSelect, setMultiSelect] = useState(false);
	const [selectedItems, setSelectedItems] = useState({});
	const [rerender, setRerender] = useState(false);
	const [home, setHome] = useState({});

	const [formats, setFormats] = useState(null);
	const [fetchFormatsComplete, setFetchFormatsComplete] = useState(false);
	const [fetchFormatsInProgress, setFetchFormatsInProgress] = useState(false);

	const getImage = key => {
		var result = getFileFormat(key, formats);
		return result ? result : { icon: "fa-file", description: "Unknown File" };
	};

	const api = new FileApi(instance, inProgress, accounts);

	const currentUploadFolder = () => FileFunctions.cleanBlobPath(selectedPath.path);

	useEffect(() => {
		context.handleSetAppSidebarMinified(true);
		context.handleSetAppHeaderInverse(true);
		context.handleSetAppContentFullHeight(true);

		var fileHasSubNodes = document.querySelectorAll(".file-node.has-sub");

		fileHasSubNodes.forEach(node => {
			var fileArrow = node.querySelector(".file-link > .file-arrow");

			fileArrow.addEventListener("click", function (event) {
				event.preventDefault();
				node.classList.toggle("expand");
			});
		});

		var fileInfoNodes = document.querySelectorAll(".file-node");

		fileInfoNodes.forEach(node => {
			var fileInfo = node.querySelector(".file-link > .file-info");

			fileInfo.addEventListener("click", function (event) {
				event.preventDefault();
				fileInfoNodes.forEach(otherNode => {
					if (otherNode !== node) {
						otherNode.classList.remove("selected");
					}
				});
				node.classList.add("expand");
				node.classList.add("selected");
			});
		});

		return () => {
			context.handleSetAppSidebarMinified(false);
			context.handleSetAppHeaderInverse(false);
			context.handleSetAppContentFullHeight(false);
		};

		// eslint-disable-next-line
	}, []);


	const fetchData = () => {
		if (!fetchInProgress) {
			if (!fetchComplete) {
				setFetchInProgress(true);
				setFetchComplete(false);
				api.getFileStructure(showDeleted)
					.then(data => {
						setHome(data.root)
						handleSetSelectedPath(data.root);
						setDataSideTree(data.root.contents);
						setRootFolderName(data.root.name);
						setConsumption(data.consumption);
					}).catch(error => {
						handleSetSelectedPath(null);
						setConsumption(null);
						setRootFolderName("");
						setDataSideTree(null);
						setPathHistory([]);
						console.log(error)
					})
					.finally(() => {
						setFetchComplete(true);
						setFetchInProgress(false);
					});
			}
		}
	};

	const fetchFormats = () => {
		if (!fetchFormatsInProgress) {
			if (!fetchFormatsComplete) {
				const docsApi = new DocsAPI(instance, inProgress, accounts);
				setFetchFormatsInProgress(true);
				setFetchFormatsComplete(false);
				docsApi.getAll()
					.then(data => {
						setFormats(data.formats);
					}).catch(error => {
						console.error("An error occurred fetching formats.", error)
					})
					.finally(() => {
						setFetchFormatsComplete(true);
						setFetchFormatsInProgress(false);
					});
			}
		}
	};

	const throttledFetch = _.debounce(fetchData, 50, { leading: true, trailing: false, maxWait: 1000 });
	const throttledFormats = _.debounce(fetchFormats, 50, { leading: true, trailing: false, maxWait: 1000 });

	useEffect(() => {
		throttledFetch();
	}, [throttledFetch]);

	useEffect(() => {
		throttledFormats();
	}, [throttledFormats]);

	const handleSetSelectedPath = (path) => {

		if (!!path && !!path.contents['$id']) {
			path = home;
		}

		setPathHistory(current => {
			if (!path || !current) {
				return [];
			}
			const result = [...current, path];
			return result;
		});

		setSelectedPath(path);
	};

	const handleMoveUp = () => {
		pathHistory.pop();
		const last = pathHistory[pathHistory.length - 1];
		setPathHistory(pathHistory);
		setSelectedPath(last);
	};

	const handleGoHome = () => {
		const home = pathHistory[0];
		setPathHistory([].concat(home));
		setSelectedPath(home);
	};

	const handleShowPreviousVersionModal = (file) => {
		setPreviousVersionsFile(file);
		setShowVersionModal(true);
	};

	const handleHidePreviousVersionModal = () => {
		setPreviousVersionsFile(null);
		setShowVersionModal(false);
	};

	const handleRefresh = () => {
		setFetchComplete(false);
		throttledFetch();
	};

	const handleSetMultiSelect = () => {

		setSelectedItems(current => {
			if (!multiSelect) {
				return {};
			}
			return current;
		});

		setMultiSelect(!multiSelect)
	};

	const handleSetSelectedItem = (item) => {

		setRerender(!rerender);

		const existingEntry = selectedItems ? selectedItems[item.path] : false;
		if (existingEntry) {
			setSelectedItems(current => {
				delete current[item.path];
				return current;
			});
		}
		else {
			setSelectedItems(current => {
				current = current ?? {};
				current[item.path] = item;
				return current;
			});
		}
	};

	const handleDeleteFiles = () => {

		// Depth-first search to find the first file object (files have containerName; folders do not)
		const getContainerNameFromSelectedItems = (items) => {
			if (!items) return null;
			const seen = new Set();
			const stack = [];
			// Start with top-level selected item values
			for (const v of Object.values(items)) {
				if (v) stack.push(v);
			}
			while (stack.length) {
				const node = stack.shift();
				if (!node || seen.has(node)) continue;
				seen.add(node);
				// If this node represents a file, it should have containerName
				if (node.containerName) return node.containerName;
				// If the node explicitly marks folder vs file, and it's a file, check again
				if (node.isFolder === false && node.containerName) return node.containerName;
				// Otherwise, push possible children/contents to the stack for DFS
				if (Array.isArray(node.contents) && node.contents.length) {
					for (const c of node.contents) stack.push(c);
				} else if (node.contents && typeof node.contents === 'object') {
					// contents might be an object map
					for (const c of Object.values(node.contents)) stack.push(c);
				}
				// common alternatives
				if (Array.isArray(node.children)) for (const c of node.children) stack.push(c);
				if (Array.isArray(node.items)) for (const c of node.items) stack.push(c);
			}
			return null;
		};

		const containerName = getContainerNameFromSelectedItems(selectedItems);
		if (!containerName) {
			console.error('Unable to determine containerName from selectedItems (no file object found)', selectedItems);
			return; // don't attempt delete without a container name
		}

		const deleteFileModel = {
			containerName: containerName,
			deletedItems: Object.entries(selectedItems).map(i => {
				return { path: i[1].path.split("/")[0] === rootFolderName ? i[1].path.split("/")[1] : i[1].path, isFolder: i[1].isFolder };
			})
		};

		api.queueFileDeletion(deleteFileModel)
			.then(() => { setSelectedItems({}); })
			.catch(error => console.log("An error occurred deleting items", error));

	};

	const handleShowDeleted = () => {
		setShowDeleted(!showDeleted);
		handleRefresh();
	}

	const handleSelectAll = () => {
		const all = {};
		for (const item of selectedPath.contents) {
			all[item.path] = item;
		}
		setSelectedItems(all);
	};

	const handleUnselectAll = () => {
		setSelectedItems({});
	};

	return (
		<div className="h-100 d-flex flex-column">

			<PreviousVersionModal
				show={showVersionModal}
				handleCancel={handleHidePreviousVersionModal}
				file={previousVersionsFile}
				getImage={getImage}
			/>

			<FileManagerPageHeader />
			<div className="file-manager h-100" id="fileManager">
				{/* <FileManagerToolbar /> */}
				<div className="file-manager-container">
					<div className="file-manager-sidebar">
						{/* <div className="file-manager-sidebar-mobile-toggler">
							<button type="button" className="btn" data-toggle-className="file-manager-sidebar-mobile-toggled" data-target="#fileManager">
								<i className="far fa-lg fa-folder"></i>
							</button>
						</div> */}
						<FileManagerTreeWindow rootFolderName={rootFolderName} contents={dataSideTree} setPath={handleSetSelectedPath} getImage={getImage} />
						<FileManagerFooter consumption={consumption} />
					</div>
					<div className="file-manager-content d-flex flex-column">
						{selectedPath && selectedPath.contents && <>

							<FileManagerSecondToolbar isRoot={!selectedPath.parent}
								moveUp={handleMoveUp}
								goHome={handleGoHome}
								refresh={handleRefresh}
								refreshDisabled={fetchInProgress}
								showDeleted={showDeleted}
								multiSelect={multiSelect}
								handleShowDeletedToggle={handleShowDeleted}
								handleShowMultiSelectToggle={handleSetMultiSelect}
								itemsSelected={Object.entries(selectedItems)}
								deleteSelectedItems={handleDeleteFiles}
								currentFolder={currentUploadFolder()}
								selectAll={handleSelectAll}
								unSelectAll={handleUnselectAll}
							/>

							<FileManagerMainWindow
								data={selectedPath.contents}
								setPath={handleSetSelectedPath}
								getImage={getImage}
								setShowPreviousModal={handleShowPreviousVersionModal}
								showCheckboxes={multiSelect}
								selectedItems={selectedItems}
								setSelectedItems={handleSetSelectedItem}
							/>
						</>
						}
					</div>
				</div>
			</div>
		</div>
	);
}